/**
 * @module OrderLines
 */

import axios from 'api/axios'

class OrderLinesHelper {
  /**
   * Fetches informe data based on provided options.
   * @async
   * @param {string} id
   */
  static async deleteOrderLine(id) {
    try {
      await axios.delete(`efactura/purschaseorder/userlineselection/${id}/`)
    } catch (error) {
      throw new Error(`Error al eliminar la línea de pedido`)
    }
  }

  /**
   * Fetches informe data based on provided options.
   * @async
   */
  static async deleteAllOrderLines() {
    try {
      await axios.delete(`efactura/purschaseorder/userlineselection/all/`)
    } catch (error) {
      throw new Error(`Error al eliminar todas las líneas de pedido`)
    }
  }
}

export default OrderLinesHelper
